module.exports = "/_next/static/images/expert-jonathan-micale-d1cefdf0a6340ac18d8024ccaa1b3df5.png";